import { AdvertiseStatus } from '../enum';

export const selectAdvertiseStatusColor = (status: string | undefined) => {
  switch (status) {
    case AdvertiseStatus.approved:
      return 'success';
    case AdvertiseStatus.pending:
      return 'info';
    case AdvertiseStatus.published:
      return 'info';
    case AdvertiseStatus.rejected:
      return 'error';
    case AdvertiseStatus.draft:
      return 'warning';
    case AdvertiseStatus.submit:
      return 'warning';
    case AdvertiseStatus.expired:
      return 'error';
    default:
      return 'error';
  }
};